/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FeePaidBy = 1 | 2;

export const FeePaidBy = {
    NUMBER_1: 1 as FeePaidBy,
    NUMBER_2: 2 as FeePaidBy
};

